/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { auth } from '@/plugins/firebase'
import { onAuthStateChanged } from 'firebase/auth'
import publicPath from '@/helpers/publicPath'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login/:email/:serviceId',
    name: 'autoLogin',
    component: () => import('@/views/login.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue')
  },
  {
    path: '/call',
    name: 'call',
    component: () => import('@/views/call.vue')
  },
  {
    path: '/back',
    component: () => import('@/layouts/goBack'),
    children: [
      {
        path: 'tracking',
        name: 'trackingMap',
        component: () => import('@/components/services/today/Map')
      },
      {
        path: 'static',
        name: 'staticMap',
        component: () => import('@/components/services/past/Map')
      },
      {
        path: 'airport',
        name: 'airportMap',
        component: () => import('@/views/airport-map.vue')
      },
      {
        path: 'edit-service',
        name: 'editService',
        props: true,
        component: () => import('@/views/edit-service.vue')
      },
      {
        path: 'chat',
        name: 'outChat',
        component: () => import('@/views/chat.vue')
      },
      {
        path: 'open',
        name: 'openUrl',
        component: () => import('@/views/open-url.vue')
      }
    ]
  },
  {
    path: '/',
    component: () => import('@/layouts/dashboard'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/index.vue')
      },
      {
        path: '/book',
        name: 'book',
        component: () => import('@/views/book.vue')
      },
      {
        path: '/services',
        name: 'services',
        component: () => import('@/views/services.vue')
      },
      {
        path: '/services/:key',
        name: 'servicesSelected',
        component: () => import('@/views/services.vue')
      },
      {
        path: '/vouchers',
        name: 'vouchers',
        component: () => import('@/views/vouchers.vue')
      },
      {
        path: '/contact',
        name: 'contact',
        component: () => import('@/views/contact.vue')
      },
      {
        path: '/chat',
        name: 'chat',
        component: () => import('@/views/chat.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: publicPath,
  routes
})

router.beforeEach((to, from, next) => {
  store.commit('setLoading', false)
  const exceptions = ['call', 'outChat', 'airportMap']
  onAuthStateChanged(auth, (user) => {
    if (['login', 'autoLogin'].includes(to.name)) {
      if (user) {
        next('/')
      } else {
        next()
      }
    } else if (user || exceptions.includes(to.name)) {
      next()
    } else {
      next('/login')
    }
  })
})

export default router
